import { render, staticRenderFns } from "./ConfigureManage.vue?vue&type=template&id=47fc733b&scoped=true"
import script from "./ConfigureManage.vue?vue&type=script&lang=js"
export * from "./ConfigureManage.vue?vue&type=script&lang=js"
import style0 from "./ConfigureManage.vue?vue&type=style&index=0&id=47fc733b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fc733b",
  null
  
)

export default component.exports